import api from '../../api/api'

// initial state
const state = {
  status: {
    getBookingTypes: null
  },
	bookingTypes: []
}

// actions
const actions = {
  getBookingTypes ({ commit, state }) {
    commit('setStatus', { getBookingTypes: api.status.PENDING })
    return api.getBookingTypes().then((response) => {
      commit('setStatus', { getBookingTypes: api.status.SUCCESS })
      commit('setBookingTypes', response.data)
    }).catch((error) => {
      commit('setStatus', { getBookingTypes: api.status.FAILURE })
    })
  },
}

const mutations = {
  setBookingTypes (state, bookingTypes) {
    state.bookingTypes = bookingTypes
  },
  setStatus (state, status) {
    Object.assign(state.status, status)
  }
}


export default {
  namespaced: true,
  state,
  actions,
  mutations
}
